import React, { useContext, useEffect } from 'react';
import { LanguageContext } from "../../context/LanguageContext";

const AiProjectsSection2 = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("AiProjectsSection2", "product/product_ai_projects2_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.AiProjectsSection2 || { Main: {} };

  return (
    <div className="container-fluid aiprojects bg-light py-5">
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-lg-5 wow fadeInLeft" data-wow-delay="0.2s">
            <div>
              <h4 className="text-primary">{LANGUAGE.Main.Content1}</h4>
              <h1 className="display-4 mb-4">{LANGUAGE.Main.Content2}</h1>
              <p className="mb-5">{LANGUAGE.Main.Content3}</p>
              <ul className="nav">
                <li className="nav-item bg-white mb-4 w-100">
                  <a className="d-flex align-items-center h4 mb-0 p-3 active" data-bs-toggle="pill" href="#aiprojectsTab-5">
                    <div className="aiprojects-icon btn-md-square bg-primary text-white me-3">
                      <span className="fas fa-save small"></span>
                    </div>
                    <span>{LANGUAGE.Main.Tab1Title}</span>
                    <i className="fas fa-chevron-right ms-auto text-muted"></i>
                  </a>
                </li>
                <li className="nav-item bg-white mb-4 w-100">
                  <a className="d-flex align-items-center h4 mb-0 p-3" data-bs-toggle="pill" href="#aiprojectsTab-6">
                    <div className="aiprojects-icon btn-md-square bg-primary text-white me-3">
                      <span className="fas fa-folder-open small"></span>
                    </div>
                    <span>{LANGUAGE.Main.Tab2Title}</span>
                    <i className="fas fa-chevron-right ms-auto text-muted"></i>
                  </a>
                </li>
                <li className="nav-item bg-white mb-4 w-100">
                  <a className="d-flex align-items-center h4 mb-0 p-3" data-bs-toggle="pill" href="#aiprojectsTab-7">
                    <div className="aiprojects-icon btn-md-square bg-primary text-white me-3">
                      <span className="fas fa-box small"></span>
                    </div>
                    <span>{LANGUAGE.Main.Tab3Title}</span>
                    <i className="fas fa-chevron-right ms-auto text-muted"></i>
                  </a>
                </li>
                <li className="nav-item bg-white mb-4 w-100">
                  <a className="d-flex align-items-center h4 mb-0 p-3" data-bs-toggle="pill" href="#aiprojectsTab-8">
                    <div className="aiprojects-icon btn-md-square bg-primary text-white me-3">
                      <span className="fas fa-play-circle small"></span>
                    </div>
                    <span>{LANGUAGE.Main.Tab4Title}</span>
                    <i className="fas fa-chevron-right ms-auto text-muted"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-lg-7 wow fadeInRight" data-wow-delay="0.2s">
            <div className="tab-content">
              <div id="aiprojectsTab-5" className="tab-pane fade show p-0 active">
                <div className="aiprojects-item">
                  <a href={LANGUAGE.Main.Img_ai_5} className="link-preview" data-lightbox="report">
                    <img src={LANGUAGE.Main.Img_ai_5} className="img-fluid w-100" alt="" />
                  </a>
                  <div className="aiprojects-content bg-white p-4">
                    <h4 className="mb-3">{LANGUAGE.Main.Tab1Title}</h4>
                    <p className="mb-4">{LANGUAGE.Main.Tab1Desc}</p>
                    <a className="btn btn-primary py-2 px-4"
                      // target="_blank" 
                      href={process.env.REACT_APP_SIGNIN_URL || "https://trade.masquant.com/authentication/sign-in"}>{LANGUAGE.Main.CTA}</a>
                    {/* <a className="btn btn-primary py-2 px-4"
                      onClick={() => alert('Stay tuned')} >{LANGUAGE.Main.CTA}</a> */}
                  </div>
                </div>
              </div>

              <div id="aiprojectsTab-6" className="tab-pane fade show p-0">
                <div className="aiprojects-item">
                  <a href={LANGUAGE.Main.Img_ai_6} className="link-preview" data-lightbox="report">
                    <img src={LANGUAGE.Main.Img_ai_6} className="img-fluid w-100" alt="" />
                  </a>
                  <div className="aiprojects-content bg-white p-4">
                    <h4 className="mb-3">{LANGUAGE.Main.Tab2Title}</h4>
                    <p className="mb-4">{LANGUAGE.Main.Tab2Desc}</p>
                    <a className="btn btn-primary py-2 px-4"
                      // target="_blank"
                      href={process.env.REACT_APP_SIGNIN_URL || "https://trade.masquant.com/authentication/sign-in"}>{LANGUAGE.Main.CTA}</a>
                    {/* <a className="btn btn-primary py-2 px-4"
                      onClick={() => alert('Stay tuned')} >{LANGUAGE.Main.CTA}</a> */}
                  </div>
                </div>
              </div>

              <div id="aiprojectsTab-7" className="tab-pane fade show p-0">
                <div className="aiprojects-item">
                  <a href={LANGUAGE.Main.Img_ai_7} className="link-preview" data-lightbox="report">
                    <img src={LANGUAGE.Main.Img_ai_7} className="img-fluid w-100" alt="" />
                  </a>
                  <div className="aiprojects-content bg-white p-4">
                    <h4 className="mb-3">{LANGUAGE.Main.Tab3Title}</h4>
                    <p className="mb-4">{LANGUAGE.Main.Tab3Desc}</p>
                    <a className="btn btn-primary py-2 px-4"
                      // target="_blank"
                      href={process.env.REACT_APP_SIGNIN_URL || "https://trade.masquant.com/authentication/sign-in"}>{LANGUAGE.Main.CTA}</a>
                    {/* <a className="btn btn-primary py-2 px-4"
                      onClick={() => alert('Stay tuned')} >{LANGUAGE.Main.CTA}</a> */}
                  </div>
                </div>
              </div>

              <div id="aiprojectsTab-8" className="tab-pane fade show p-0">
                <div className="aiprojects-item">
                  <a href={LANGUAGE.Main.Img_ai_8} className="link-preview" data-lightbox="report">
                    <img src={LANGUAGE.Main.Img_ai_8} className="img-fluid w-100" alt="" />
                  </a>
                  <div className="aiprojects-content bg-white p-4">
                    <h4 className="mb-4">{LANGUAGE.Main.Tab4Title}</h4>
                    <p className="mb-4">{LANGUAGE.Main.Tab4Desc}</p>
                    <a className="btn btn-primary py-2 px-4"
                      // target="_blank"
                      href="https://trade.masquant.com/authentication/sign-in">{LANGUAGE.Main.CTA}</a>
                    {/* <a className="btn btn-primary py-2 px-4"
                      onClick={() => alert('Stay tuned')} >{LANGUAGE.Main.CTA}</a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AiProjectsSection2;
